const aboutEN = {
	title: "About ReservaSinFila",
	whoWeAre: {
		title: "Who We Are",
		text: "ReservaSinFila is a modern booking platform created to simplify how people schedule appointments with service professionals. No more waiting, guessing availability, or messaging back and forth. Our goal is to make the entire scheduling experience effortless for both clients and businesses.",
	},
	clients: {
		title: "For Clients",
		text: "Quickly find and book appointments with trusted professionals across multiple industries. View real availability, choose your preferred time, receive automatic reminders, and manage everything from your phone. Fast, simple, and convenient.",
	},
	staff: {
		title: "For Professionals & Business Owners",
		text: "Manage your schedule, reduce no-shows, and grow your business with powerful tools for appointments, services, staff, payments, and client communication. ReservaSinFila brings organization, automation, and efficiency to keep your business running smoothly.",
	},
	mission: {
		title: "Our Mission",
		text: "Our mission is to modernize service-based businesses across Latin America and beyond. We empower professionals and clients with technology that eliminates friction, saves time, and creates a better end-to-end experience.",
	},
	tech: {
		title: "Technology & Reliability",
		text: "Powered by modern technologies such as React and AWS, ReservaSinFila is designed for speed, security, and scalability. We prioritize stability and reliability so clients and professionals can trust the platform every day.",
	},
	future: {
		title: "Future Vision",
		text: "We are continuously improving, preparing to release full mobile apps, expanding into new categories, and adding advanced features for businesses of all sizes. The platform will evolve with the needs of our community.",
	},
	joinUs: {
		title: "Join Us",
		text: "Whether you're a client looking for trusted professionals or a business wanting better tools, ReservaSinFila is here to make your life easier. Start today and experience a smarter way to book.",
	},
};

export default aboutEN;
